export const UNKNOWN_CURRENCY_PREFIX = 'UNKNOWN_CURRENCY_';
